angular.module('impactx.sidebar').factory('sidebarShow', [
    '$mdSidenav',
    SidebarFactory
]);

function SidebarFactory($mdSidenav) {
    var self = this;
    var isShown = true;
    var toggleIsHidden = false;

    self.toggle = function (sidebarId) {
        if (sidebarId) {
            $mdSidenav(sidebarId).toggle();
        }
        else {
            isShown = !isShown;
        }
    };

    self.open = function (sidebarId) {
        if (sidebarId) {
            $mdSidenav(sidebarId).open();
        }
        else {
            isShown = true;
        }
    };

    self.close = function (sidebarId) {
        if (sidebarId) {
            $mdSidenav(sidebarId).close();
        }
        else {
            isShown = false;
        }
    };

    self.isOpen = function (sidebarId) {
        if (sidebarId) {
            return $mdSidenav(sidebarId).isOpen();
        }
        else {
            return isShown;
        }
    };

    self.toggleIsHidden = function () {
        return toggleIsHidden;
    };

    self.setToggleIsHidden = function (value) {
        toggleIsHidden = value;
    };

    return {
        open: self.open,
        close: self.close,
        isOpen: self.isOpen,
        toggle: self.toggle,
        toggleIsHidden: self.toggleIsHidden,
        setToggleIsHidden: self.setToggleIsHidden
    }
}